/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useNavigation, useAuth } from "react-uicomp";
import { CSSTransition } from "react-transition-group";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getContactAction, getVacancyAction } from "../../../actions/Actions";
import {
  MdEvent,
  FaBook,
  MdClose,
  FaNewspaper,
  FaBookOpen,
  FaRegImages,
  MdEmail,
  FaHandsHelping,
  IoIosPeople,
  MdLocalMovies,
  FaBullhorn,
  MdCall,
  MdFindInPage,
  FaBookReader,
} from "react-icons/all";

import LOGO from "../../../assets/logo192.png";

const ICONS = {
  News: <FaNewspaper size={20} />,
  Publication: <FaBookOpen size={20} />,
  Presentation: <FaRegImages size={22} />,
  Event: <MdEvent size={24} />,
  NewsLetter: <MdEmail size={22} />,
  Collaborator: <FaHandsHelping size={24} />,
  "Team Member": <IoIosPeople size={26} />,
  "Conference Presentation": <MdLocalMovies />,
  "Research Paper": <FaBook size={20} />,
  Vacancy: <FaBullhorn size={20} />,
  Contact: <MdCall size={22} />,
  Research: <MdFindInPage size={24} />,
  "Research Program": <MdFindInPage size={24} />,
  Study: <FaBookReader size={20} />,
};

const mapStateToProps = (state) => {
  return {
    contact: state.contact,
    vacancy: state.vacancy,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getContactAction,
      getVacancyAction,
    },
    dispatch,
  );
};

const SideNav = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props) => {
  const { contact, vacancy, getContactAction, getVacancyAction } = props;
  const { navigation } = useNavigation();
  const { setSideNavVisible } = useAuth();
  const { routes } = navigation;

  useEffect(() => {
    getContactAction(1);
    getVacancyAction(1);
  }, [getContactAction, getVacancyAction]);

  return (
    <div className="sidenavigation-container">
      <div className="sidenavigation">
        <div
          className="sidenavigation-header"
          onClick={() => navigation.navigate("/")}>
          <img src={LOGO} alt="NIRC Logo" />
        </div>

        <ul
          className="sidenavigation-list"
          onClick={() => setSideNavVisible(false)}>
          {Object.keys(routes).map(
            (route, index) =>
              routes[route].props !== "isSub" && (
                <li className="sidenavigation-list-item" key={index}>
                  <a
                    href={routes[route].path}
                    onClick={(e) => {
                      e.preventDefault();
                      navigation.navigate(routes[route].path);
                    }}
                    className={routes[route].active ? "active" : ""}>
                    <span className="icon">{ICONS[routes[route].name]}</span>
                    <span className="title">{routes[route].name}</span>
                  </a>

                  {routes[route].name === "Vacancy" &&
                    Number(vacancy?.listCount) !== 0 && (
                      <div className="sidenavigation-list-item-badge">
                        {vacancy?.listCount}
                      </div>
                    )}

                  {routes[route].name === "Contact" &&
                    Number(contact?.listCount) !== 0 && (
                      <div className="sidenavigation-list-item-badge">
                        {contact?.listCount}
                      </div>
                    )}
                </li>
              ),
          )}
        </ul>
      </div>
    </div>
  );
});

export default function SideNavigation(props) {
  const { mobileSideNavVisible, setMobileSideNavVisible } = props;
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) {
    return (
      <>
        <CSSTransition
          in={mobileSideNavVisible}
          timeout={200}
          classNames="sidenavigation-node"
          unmountOnExit>
          <div className="sidenavigation-mobile-container">
            <div className="sidenavigation-mobile">
              <SideNav />

              <div
                className="close-sidenav"
                onClick={() => setMobileSideNavVisible(false)}>
                <MdClose />
              </div>
            </div>
          </div>
        </CSSTransition>

        <div className="sidenavigation-web">
          <SideNav />
        </div>
      </>
    );
  } else {
    return null;
  }
}
